module.exports = __webpack_public_path__ + "static/media/download-csv.0e8bb506.svg";